<template>
  <div class="pb-6">
    <div class="col-xl-12 col-lg-12">
      <div class="m-portlet--full-height m-portlet--tabs">
        <EmptyState v-if="noTasks" :textContent="this.$t('message.certificates.emptyState.noCert2')"
          moreTextContent="false" />
        <div v-else class="containerUploadFiles m-auto flex justify-center xl:justify-between">
          <div class="leftContainer w-full max-w-3xl xl:max-w-none xl:w-1/2 shadowContainers flex flex-col">
            <fileUploadFilters ref="filters" @update-documents="updateWaitingDocuments()" @check-all="
              leftContainer.massiveArrayUsers = [];
            getForMassiveUserArray();
            " @clean-massivearray="leftContainer.massiveArrayUsers = []" :selected-user="leftContainer.selectedUser"
              @clean-selected-user="leftContainer.selectedUser = {}" :isCheckAll="leftContainer.isCheckAll" />
            <pendingDocumentCardHeader :selected-items="leftContainer.massiveArrayUsers.length"
              :visible-items="leftContainer.cards.usersData.length" :total-items="leftContainer.totalDocuments"
              @select-all="
                leftContainer.isCheckAll = true;
              checkBoxMassiveApprove();
              " @select-visible="selectVisibleItems" @clear-all-selected="clearSelectedItems"
              @order-list="changeOrderRule" />
            <div :class="Object.keys(leftContainer.selectedUser).length >= 1
                ? 'containerUploadFilesSelected'
                : 'CardsContainer'
              ">
              <PendingDocumentCard v-for="(pendingDocument, index) in leftContainer.cards.usersData" :key="index"
                :pendingDocument="pendingDocument" :selectedDocument="leftContainer.selectedUser" @selectCard="(document) => {
                    selectCard(document);
                  }
                  " @pushCardToMassiveArray="(document) => {
      pushCardToMassiveArray(document);
    }
    " />

              <infinite-loading v-if="infiniteLoadingEnable" ref="infiniteLoading" spinner="spiral"
                @infinite="getListDocumentsWaiting">
                <div class="noMoreResults" slot="no-more">
                  <span>{{
                    $t('message.uploadImageComponent.body.leftContainer.noMoreResults')
                  }}</span>
                </div>

                <div class="noMoreResults" slot="no-results">
                  <span v-if="leftContainer.cards.searchingFromFilters && documentPage === 1">
                    {{
                      $t(
                        'message.uploadImageComponent.body.leftContainer.noMoreSearchingFromUser'
                      )
                    }}
                  </span>
                  <span v-else>{{
                    $t('message.uploadImageComponent.body.leftContainer.noMoreResults')
                  }}</span>
                </div>
              </infinite-loading>
            </div>
          </div>
          <div class="rightContainer shadowContainers w-1/2 ml-6 hidden xl:block">
            <div v-if="leftContainer.massiveArrayUsers.length > 1">
              <multipleSelectionPreview :approveLoadData="rightContainer.approveLoadData"
                :rejectLoadData="rightContainer.rejectLoadData"
                :isInitHeight="Object.keys(leftContainer.selectedUser).length === 0"
                @approveLoad="openMultipleApproveModal()" @openModalAndSaveRejectData="openMultipleRejectModal()" />
            </div>
            <div v-else-if="Object.keys(leftContainer.selectedUser).length === 0" class="rightContainerFlexEmptyState">
              <div class="noContentEmptyStateContainer">
                <span><img src="../../../public/assets/images/uploadFiles/noContentEmptyState.png" alt="" /></span>
                <span class="noContentEmptyStateTitle">{{
                  $t(
                    'message.uploadImageComponent.body.rightContainer.noContentEmptyState.title'
                  )
                }}</span>
                <span class="noContentEmptyStateContent">{{
                  $t(
                    'message.uploadImageComponent.body.rightContainer.noContentEmptyState.content'
                  )
                }}</span>
              </div>
            </div>
            <div class="h-full" v-else-if="Object.keys(leftContainer.selectedUser)">
              <self-service-preview v-if="windowResize.width >= 1280 &&
                leftContainer.selectedUser.id_type_flows === '2'
                " :user="leftContainer.selectedUser" :key="this.rightContainer.keyForReRender"
                :approveLoadData="rightContainer.approveLoadData" :rejectLoadData="rightContainer.rejectLoadData"
                @approveLoad="approveLoad" @openModalAndSaveRejectData="openIndividualModalAndSaveRejectData" />
              <fileUploadVisualizer v-if="windowResize.width >= 1280 &&
                leftContainer.selectedUser.id_type_flows !== '2'
                " :user="leftContainer.selectedUser" :key="this.rightContainer.keyForReRender"
                :approveLoadData="rightContainer.approveLoadData" :rejectLoadData="rightContainer.rejectLoadData"
                @approveLoad="approveLoad" @openModalAndSaveRejectData="openIndividualModalAndSaveRejectData" />
            </div>
          </div>
        </div>

        <zt-modal v-if="windowResize.width < 1280" :active="modalFileUploadVisualizer"
          @close="modalFileUploadVisualizer = false" max-width="750px" :z-index="1001" :fullscreen="breakpointLG"
          class="modalFileUploadVisualizer" :class="{
            hidden: rightContainer.rejectLoadData.modalRejectIndividual && !breakpointLG,
          }" :title="$t('message.uploadImageComponent.modals.fileUploadVisualizerTitle')">
          <div class="h-full">
            <self-service-preview v-if="leftContainer.selectedUser.id_type_flows === '2'"
              :user="leftContainer.selectedUser" :key="this.rightContainer.keyForReRender"
              :approveLoadData="rightContainer.approveLoadData" :rejectLoadData="rightContainer.rejectLoadData"
              @approveLoad="approveLoad" @openModalAndSaveRejectData="openIndividualModalAndSaveRejectData" />
            <fileUploadVisualizer v-if="leftContainer.selectedUser.id_type_flows !== '2'"
              :user="leftContainer.selectedUser" :key="this.rightContainer.keyForReRender"
              :approveLoadData="rightContainer.approveLoadData" :rejectLoadData="rightContainer.rejectLoadData"
              @approveLoad="approveLoad" @openModalAndSaveRejectData="openIndividualModalAndSaveRejectData" />
          </div>
        </zt-modal>
        <zt-modal :active="rightContainer.rejectLoadData.modalRejectIndividual ||
          rightContainer.rejectLoadData.modalRejectMultiple
          " @close="closeRejectModalAndUpdateTasks()" :z-index="101" class="modalRejectIndividual">
          <template slot="modal-header">
            <div class="modal-header px-8 py-3 text-white font-bold">
              <h4>
                {{ modalRejectTitle }}
              </h4>
            </div>
          </template>
          <div>
            <transition name="slide-fade">
              <ModalRejectIndividualSuccessful v-if="rightContainer.rejectLoadData.modalRejectedSuccessful &&
                !rightContainer.rejectLoadData.modalRejectMultiple
                " @closeRejectModalAndUpdateTasks="closeRejectModalAndUpdateTasks()"
                :documentRejectedName="rightContainer.rejectLoadData.documentName" />
              <ModalRejectSuccessfulMassive v-if="rightContainer.rejectLoadData.modalRejectedSuccessful &&
                rightContainer.rejectLoadData.modalRejectMultiple
                " @closeRejectModalAndUpdateTasks="closeRejectModalAndUpdateTasks()"
                :rejectedDocuments="rightContainer.rejectLoadData.rejectedDocuments" />
              <ModalHandledErrors v-if="rightContainer.rejectLoadData.modalHandledErrors &&
                !rightContainer.rejectLoadData.modalRejectedSuccessful
                " @closeModalAndUpdateTask="closeRejectModalAndUpdateTasks()" @denyLoad="denyLoad('multiple')"
                :listOfErrors="rightContainer.rejectLoadData.errors" :loading="rightContainer.rejectLoadData.loading"
                :typeOfRetry="rightContainer.typeOfRetry" />
            </transition>
            <ModalRejectDocuments v-if="!rightContainer.rejectLoadData.modalRejectedSuccessful &&
              !rightContainer.rejectLoadData.modalHandledErrors
              " v-model="rightContainer.rejectLoadData.rejectIndividualTextArea"
              @closeRejectModalAndUpdateTasks="closeRejectModalAndUpdateTasks()" @denyLoad="
                rightContainer.rejectLoadData.modalRejectMultiple
                  ? denyLoad('multiple')
                  : denyLoad(
                    'individual',
                    rightContainer.rejectLoadData.rejectId,
                    rightContainer.rejectLoadData.typeOfDocument
                  )
                " :loading="rightContainer.rejectLoadData.loading"
              :modalRejectMultiple="rightContainer.rejectLoadData.modalRejectMultiple"
              :documentsAmount="leftContainer.massiveArrayUsers.length" />
          </div>
        </zt-modal>

        <zt-modal :active="modalErrorIndividual" @close="modalErrorIndividual = false" class="modalIndividualError">
          <template slot="modal-header">
            <div class="modal-header px-8 py-3 text-white font-bold">
              <h4>
                {{ $t('message.uploadImageComponent.modals.individualErrorModalTitle') }}
              </h4>
            </div>
          </template>
          <div>
            <ModalErrorIndividualContent />
          </div>
          <template slot="modal-footer">
            <div class="zt-modal-footer flex justify-center lg:justify-end items-center p-4">
              <zt-button data-vs-button="understand" class="ml-1" @click="modalErrorIndividual = false">{{
                $t('message.uploadImageComponent.modals.buttonUnderstand')
              }}</zt-button>
            </div>
          </template>
        </zt-modal>

        <zt-modal :active="rightContainer.approveLoadData.modalApproveMultiple" @close="
          !rightContainer.approveLoadData.modalHandledErrors &&
            !rightContainer.approveLoadData.modalApproveSuccessful
            ? closeApproveModalAndUpdateTask('firstStep')
            : closeApproveModalAndUpdateTask()
          " class="modalApproveMultiple">
          <template slot="modal-header">
            <div class="modal-header px-8 py-3 text-white font-bold">
              <h4>{{ modalMasiveApproveTitle }}</h4>
            </div>
          </template>
          <div>
            <ModalApproveDocuments v-if="!rightContainer.approveLoadData.modalHandledErrors &&
              !rightContainer.approveLoadData.modalApproveSuccessful
              " :documentsAmount="leftContainer.massiveArrayUsers.length"
              :loading="rightContainer.approveLoadData.loading" @closeApproveModalAndUpdateTask="
                closeApproveModalAndUpdateTask('firstStep')
                " @approveLoad="approveLoad('multiple')" />
            <transition name="slide-fade">
              <ModalHandledErrors v-if="rightContainer.approveLoadData.modalHandledErrors &&
                !rightContainer.approveLoadData.modalApproveSuccessful
                " @closeModalAndUpdateTask="closeApproveModalAndUpdateTask()" @approveLoad="approveLoad('multiple')"
                :listOfErrors="rightContainer.approveLoadData.errors" :loading="rightContainer.approveLoadData.loading"
                :typeOfRetry="rightContainer.typeOfRetry" />
              <ModalApproveSuccessful v-if="rightContainer.approveLoadData.modalApproveSuccessful"
                :modalApproveSuccessful="rightContainer.approveLoadData.modalApproveSuccessful
                  " @closeApproveModalAndUpdateTask="closeApproveModalAndUpdateTask()"
                :documentsAmount="rightContainer.approveLoadData.approvedDocuments" />
            </transition>
          </div>
        </zt-modal>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueElementLoading from 'vue-element-loading';
import inViewportDirective from 'vue-in-viewport-directive';
import InfiniteLoading from 'vue-infinite-loading';
import swal from 'sweetalert2';
import fileUploadVisualizer from './fileUploadVisualizer.vue';
import multipleSelectionPreview from './multipleSelectionPreview.vue';
import pendingDocumentCardHeader from './pendingDocumentCardHeader';
import ModalErrorIndividualContent from './modals/modalErrorIndividual.vue';
import ModalRejectDocuments from './modals/modalRejectDocuments.vue';
import ModalRejectIndividualSuccessful from './modals/modalRejectSuccessfulIndividual.vue';
import ModalRejectSuccessfulMassive from './modals/modalRejectSuccessfulMassive.vue';
import ModalHandledErrors from './modals/modalHandledErrors.vue';
import ModalApproveDocuments from './modals/modalApproveDocuments';
import ModalApproveSuccessful from './modals/modalApproveSuccessful';
import PendingDocumentCard from './pendingDocumentCard';
import fileUploadFilters from './fileUploadFilters.vue';
import User from '../../apiClient/Employee';
import _ from 'lodash';
import { useWindowResize } from '@sichern/ui-elements';
import EmptyState from '../certificates/components/EmptyState.vue';
import SelfServicePreview from './selfService/SelfServicePreview';

Vue.directive('in-viewport', inViewportDirective);

const genreDefaultValues = [
  {
    label: 'Hombre',
    value: 'M',
  },
  {
    label: 'Mujer',
    value: 'F',
  },
  {
    label: 'No Binario',
    value: 'N',
  },
  {
    label: 'Prefiero no indicar',
    value: 'U',
  },
];

const parseGenreValue = (genre) => {
  const genreValue = genreDefaultValues.find(
    (defaultValue) => defaultValue.value === genre
  );

  return genreValue ? genreValue.label : genre;
};

export default {
  inject: ['state', 'mutations'],
  components: {
    PendingDocumentCard,
    InfiniteLoading,
    VueElementLoading,
    fileUploadVisualizer,
    multipleSelectionPreview,
    pendingDocumentCardHeader,
    ModalErrorIndividualContent,
    ModalRejectDocuments,
    ModalRejectIndividualSuccessful,
    ModalRejectSuccessfulMassive,
    ModalHandledErrors,
    ModalApproveDocuments,
    ModalApproveSuccessful,
    fileUploadFilters,
    EmptyState,
    SelfServicePreview,
  },
  data() {
    return {
      windowResize: useWindowResize(this),
      UserApi: User,
      noTasks: false,
      modalFileUploadVisualizer: false,
      modalErrorIndividual: false,
      leftContainer: {
        cards: {
          problemOnMassive: false,
          loadingCards: false,
          searchingFromFilters: false,
          usersData: [],
          usersAvatars: [],
        },
        selectedUser: {},
        massiveArrayUsers: [],
        isCheckAll: false,
        totalDocuments: 0,
        listOrder: {
          orderBy: '',
          orderType: 'asc',
        },
      },
      rightContainer: {
        keyForReRender: 0,
        typeOfRetry: '',
        approveLoadData: {
          loading: false,
          approved: false,
          modalApproveMultiple: false,
          modalApproveSuccessful: false,
          modalHandledErrors: false,
          approvedDocuments: 0,
          errors: [],
        },
        rejectLoadData: {
          loading: false,
          rejectId: '',
          rejectIndividualTextArea: '',
          documentName: '',
          typeOfDocument: '',
          modalRejectIndividual: false,
          modalRejectMultiple: false,
          modalRejectedSuccessful: false,
          modalHandledErrors: false,
          rejectedDocuments: 0,
          rejectedSuccessful: false,
          errors: [],
        },
      },

      loadingView: true,
      infiniteLoadingEnable: true,
      documentPerPage: 10,
      documentPage: 1,
      taskApprovedIndex: null,
    };
  },
  computed: {
    modalMasiveApproveTitle() {
      if (
        !this.rightContainer.approveLoadData.modalHandledErrors &&
        !this.rightContainer.approveLoadData.modalApproveSuccessful
      ) {
        return this.$t('message.uploadImageComponent.modals.multipleApproveModalTitle');
      } else if (this.rightContainer.approveLoadData.modalApproveSuccessful) {
        return this.$t('message.uploadImageComponent.modals.multipleApproveSuccess');
      } else if (
        this.rightContainer.approveLoadData.modalHandledErrors &&
        !this.rightContainer.approveLoadData.modalApproveSuccessful
      ) {
        return this.$t('message.uploadImageComponent.modals.handledErrorsModalTitle');
      }
    },
    modalRejectTitle() {
      if (
        this.rightContainer.rejectLoadData.modalRejectedSuccessful &&
        this.rightContainer.rejectLoadData.modalRejectIndividual
      ) {
        return this.$t(
          'message.uploadImageComponent.modals.individualRejectSuccessfulModalTitle'
        );
      } else if (
        this.rightContainer.rejectLoadData.modalRejectedSuccessful &&
        this.rightContainer.rejectLoadData.modalRejectMultiple
      ) {
        return this.$t(
          'message.uploadImageComponent.modals.multipleRejectDocumentRejected'
        );
      } else if (
        this.rightContainer.rejectLoadData.modalHandledErrors &&
        this.rightContainer.rejectLoadData.modalRejectMultiple &&
        !this.rightContainer.rejectLoadData.modalRejectedSuccessful
      ) {
        return this.$t('message.uploadImageComponent.modals.handledErrorsModalTitle');
      } else {
        return this.$t('message.uploadImageComponent.modals.individualRejectModalTitle');
      }
    },
    breakpointMD: function () {
      return this.windowResize.width < 769;
    },
    breakpointLG: function () {
      return this.windowResize.width < 1280;
    },
  },
  created() {
    this.UserApi = new User();
  },
  watch: {
    'rightContainer.rejectLoadData.modalRejectIndividual': function () {
      if (this.rightContainer.rejectLoadData.modalRejectIndividual === false) {
        this.rightContainer.rejectLoadData.rejectIndividualTextArea = '';
      }
    },
    'rightContainer.rejectLoadData.modalRejectedSuccessful': function () {
      if (this.rightContainer.rejectLoadData.modalRejectedSuccessful === false) {
        this.rightContainer.rejectLoadData.rejectId = '';
      }
    },
    'leftContainer.cards.usersData': function () {
      setTimeout(this.scrollTopTaskSelected(), 1500);
    },
    'windowResize.width': function () {
      if (this.windowResize.width > 1279) {
        this.modalFileUploadVisualizer = false;
      }
    },
  },
  methods: {
    async approveLoad(parameterLoad, obj = {}) {
      this.rightContainer.approveLoadData.loading = true;
      this.rightContainer.approveLoadData.approved = false;
      if (parameterLoad === 'individual') {
        this.rightContainer.approveLoadData.loading = true;
        const loadId = obj.approveId;
        const type = obj.type;
        try {
          if (type === '2') await this.UserApi.approveSelfServiceInfo(loadId);
          else await this.UserApi.appproveLoad(loadId);
          this.rightContainer.approveLoadData.loading = false;
          this.rightContainer.approveLoadData.approved = true;
          setTimeout(() => {
            this.leftContainer.selectedUser = {};
            this.leftContainer.massiveArrayUsers = [];
            this.updateWaitingDocuments(parameterLoad, loadId);
            this.rightContainer.approveLoadData.approved = false;
          }, 1500);
        } catch (e) {
          this.rightContainer.approveLoadData.loading = false;
          return this.errorOnFinishLoad(e, parameterLoad);
        }
      } else {
        this.leftContainer.cards.loadingCards = true;
        this.rightContainer.approveLoadData.errors = await this.processBulkApprove();
        if (this.rightContainer.approveLoadData.errors.length === 0) {
          this.rightContainer.approveLoadData.approvedDocuments = this.leftContainer.massiveArrayUsers.length;
          this.rightContainer.approveLoadData.modalApproveSuccessful = true;
          this.rightContainer.approveLoadData.loading = false;
          this.leftContainer.massiveArrayUsers = [];
        } else {
          this.leftContainer.massiveArrayUsers = this.rightContainer.approveLoadData.errors;
          this.rightContainer.approveLoadData.loading = false;
          this.rightContainer.approveLoadData.modalHandledErrors = true;
          this.rightContainer.typeOfRetry = 'approve';
        }
      }
      await this.$store.dispatch('setDocumentsWaiting', {
        perPage: 10,
        page: 1,
        orderParams: null,
      });
    },
    async processBulkApprove() {
      let i = this.leftContainer.massiveArrayUsers.length;
      let position = this.leftContainer.massiveArrayUsers.length;
      let errors = [];
      while (i--) {
        position--;
        try {
          if (this.leftContainer.massiveArrayUsers[position].id_type_flows === '2') {
            await this.UserApi.approveSelfServiceInfo(
              this.leftContainer.massiveArrayUsers[position].id_carga
            );
          } else {
            await this.UserApi.appproveLoad(
              this.leftContainer.massiveArrayUsers[position].id_carga
            );
          }
        } catch (e) {
          errors.push(this.leftContainer.massiveArrayUsers[position]);
        }
      }
      return errors;
    },
    async denyLoad(parameterLoad, loadId, type) {
      if (parameterLoad === 'individual') {
        this.rightContainer.rejectLoadData.loading = true;
        const msg = this.rightContainer.rejectLoadData.rejectIndividualTextArea;
        try {
          if (type === '2') await this.UserApi.rejectSelfServiceInfo(loadId, msg);
          else await this.UserApi.denyLoad(loadId, msg);
          this.rightContainer.rejectLoadData.loading = false;
          this.rightContainer.rejectLoadData.modalRejectedSuccessful = true;
        } catch (e) {
          this.rightContainer.rejectLoadData.modalRejectIndividual = false;
          this.rightContainer.rejectLoadData.loading = false;
          return this.errorOnFinishLoad(e, parameterLoad);
        }
      } else {
        const msg = this.rightContainer.rejectLoadData.rejectIndividualTextArea;
        await this.massiveRejectDocuments(msg);
      }
      await this.$store.dispatch('setDocumentsWaiting', {
        perPage: 10,
        page: 1,
        orderParams: null,
      });
    },
    async massiveRejectDocuments(msg) {
      this.rightContainer.rejectLoadData.loading = true;
      this.leftContainer.cards.loadingCards = true;
      this.rightContainer.rejectLoadData.errors = await this.rejectDocumentsProcess(msg);
      if (!this.rightContainer.rejectLoadData.errors.length) {
        this.rightContainer.rejectLoadData.rejectedDocuments = this.leftContainer.massiveArrayUsers.length;
        this.rightContainer.rejectLoadData.modalRejectedSuccessful = true;
        this.rightContainer.rejectLoadData.loading = false;
        this.rightContainer.rejectLoadData.rejectedSuccessful = true;
        this.leftContainer.massiveArrayUsers = [];
      } else {
        this.leftContainer.massiveArrayUsers = this.rightContainer.rejectLoadData.errors;
        this.rightContainer.rejectLoadData.loading = false;
        this.rightContainer.rejectLoadData.modalHandledErrors = true;
        this.rightContainer.typeOfRetry = 'reject';
      }
    },
    async rejectDocumentsProcess(msg) {
      const errors = [];
      let position = this.leftContainer.massiveArrayUsers.length;
      let i = this.leftContainer.massiveArrayUsers.length;
      while (i--) {
        position--;
        try {
          const id = this.leftContainer.massiveArrayUsers[position].id_carga;
          if (this.leftContainer.massiveArrayUsers[position].id_type_flows === '2') {
            await this.UserApi.rejectSelfServiceInfo(id, msg);
          } else {
            await this.UserApi.denyLoad(id, msg);
          }
        } catch (e) {
          errors.push(this.leftContainer.massiveArrayUsers[position]);
        }
      }
      return errors;
    },
    openIndividualModalAndSaveRejectData(obj) {
      if (this.rightContainer.rejectLoadData.modalRejectIndividual === false) {
        this.rightContainer.rejectLoadData.modalRejectIndividual = true;
        this.rightContainer.rejectLoadData.rejectId = obj.rejectId;
        this.rightContainer.rejectLoadData.documentName = obj.document;
        this.rightContainer.rejectLoadData.typeOfDocument = obj.type;
      }
    },
    openMultipleRejectModal() {
      if (this.rightContainer.rejectLoadData.modalRejectMultiple === false) {
        this.rightContainer.rejectLoadData.modalRejectMultiple = true;
      }
    },
    openMultipleApproveModal() {
      if (this.rightContainer.approveLoadData.modalApproveMultiple === false) {
        this.rightContainer.approveLoadData.modalApproveMultiple = true;
      }
    },
    closeRejectModalAndUpdateTasks() {
      if (
        this.rightContainer.rejectLoadData.modalRejectedSuccessful &&
        this.rightContainer.rejectLoadData.modalRejectIndividual
      ) {
        this.rightContainer.rejectLoadData.modalRejectIndividual = false;
        this.rightContainer.rejectLoadData.modalRejectedSuccessful = false;
        this.leftContainer.massiveArrayUsers = [];
        this.updateWaitingDocuments(
          'individual',
          this.rightContainer.rejectLoadData.rejectId
        );
      } else if (
        (this.rightContainer.rejectLoadData.modalRejectedSuccessful &&
          this.rightContainer.rejectLoadData.modalRejectMultiple) ||
        (this.rightContainer.rejectLoadData.modalHandledErrors &&
          this.rightContainer.rejectLoadData.modalRejectMultiple)
      ) {
        this.rightContainer.rejectLoadData.modalRejectIndividual = false;
        this.rightContainer.rejectLoadData.modalRejectMultiple = false;
        this.rightContainer.rejectLoadData.modalRejectedSuccessful = false;
        this.rightContainer.rejectLoadData.rejectedDocuments = 0;
        this.rightContainer.rejectLoadData.modalHandledErrors = false;
        this.rightContainer.typeOfRetry = '';
        this.leftContainer.selectedUser = {};
        this.updateWaitingDocuments();
        if (this.leftContainer.massiveArrayUsers.length) {
          this.toggleDocumentState();
        }
      } else {
        this.rightContainer.rejectLoadData.modalRejectIndividual = false;
        this.rightContainer.rejectLoadData.modalRejectMultiple = false;
      }
    },
    closeApproveModalAndUpdateTask(step) {
      if (step === 'firstStep') {
        this.rightContainer.approveLoadData.modalApproveMultiple = false;
      } else {
        this.leftContainer.selectedUser = {};

        this.rightContainer.approveLoadData.approvedDocuments = 0;
        this.rightContainer.approveLoadData.modalApproveMultiple = false;
        this.rightContainer.approveLoadData.modalApproveSuccessful = false;
        this.rightContainer.approveLoadData.modalHandledErrors = false;
        this.rightContainer.typeOfRetry = '';
        this.updateWaitingDocuments();
        if (this.leftContainer.massiveArrayUsers.length) {
          this.toggleDocumentState();
        }
      }
    },
    errorOnFinishLoad(error, parameterLoad) {
      if (parameterLoad && parameterLoad === 'individual') {
        this.modalErrorIndividual = true;
      } else {
        this.leftContainer.massiveArrayUsers = [];
        this.leftContainer.selectedUser = {};
        this.leftContainer.cards.problemOnMassive = true;
        if (this.leftContainer.cards.problemOnMassive === true) {
          swal({
            type: 'error',
            title: this.$t(
              'message.uploadImageComponent.errorLogs.' + error.response.data.code
            ),
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: '#54CAA6',
            confirmButtonText: this.$t(
              'message.uploadImageComponent.body.swalButtons.accept'
            ),
          }).then(() => {
            this.updateWaitingDocuments();
          });
        }
      }
    },
    selectCard(selectedUser) {
      if (selectedUser.template.genre) {
        selectedUser.template.genre = parseGenreValue(selectedUser.template.genre);
      }
      this.leftContainer.selectedUser = selectedUser;
      this.rightContainer.keyForReRender = selectedUser.id_carga;
      let windowWidth = window.innerWidth;
      if (windowWidth < 1280) {
        this.modalFileUploadVisualizer = true;
      }
    },
    pushCardToMassiveArray(item) {
      const index = _.findIndex(
        this.leftContainer.massiveArrayUsers,
        (e) => e.id_carga === item.id_carga,
        0
      );
      if (item.selectedCard && index > -1) {
        item.selectedCard = false;
        this.leftContainer.massiveArrayUsers.splice(index, 1);
      } else {
        item.selectedCard = true;
        this.leftContainer.massiveArrayUsers.push(item);
      }
      this.leftContainer.isCheckAll =
        this.leftContainer.totalDocuments > 0 &&
        this.leftContainer.totalDocuments === this.leftContainer.massiveArrayUsers.length;
    },
    checkBoxMassiveApprove() {
      this.leftContainer.massiveArrayUsers = [];
      if (this.leftContainer.isCheckAll) {
        this.getForMassiveUserArray();
      } else {
        this.toggleDocumentState();
      }
    },
    selectVisibleItems() {
      this.leftContainer.massiveArrayUsers = [];
      this.leftContainer.massiveArrayUsers.push(...this.leftContainer.cards.usersData);
      this.toggleDocumentState();
    },
    clearSelectedItems() {
      this.leftContainer.massiveArrayUsers = [];
      this.toggleDocumentState();
    },
    avatarIsLoaded(userId) {
      return _.find(
        this.leftContainer.cards.usersAvatars,
        (obj) => obj.id_usuario === userId
      );
    },
    getAvatarListByUser(users) {
      const usersWithoutDuplicates = _.uniqBy(users, (v) => v.id_usuario);
      _.each(usersWithoutDuplicates, async (user) => {
        if (!this.avatarIsLoaded(user.id_usuario)) {
          const newUserData = {
            id_usuario: user.id_usuario,
            loadName: user.template.alias,
          };
          try {
            const avatar = await this.UserApi.getAvatar(user.id_usuario);
            if (avatar) {
              Object.assign(newUserData, {
                profilePic: `${avatar.data}`,
              });
            } else {
              Object.assign(newUserData, {
                errorOnProfilePick: `${user.nombre_usuario.charAt(
                  0
                )}${user.apellido.charAt(0)}`,
              });
            }
          } catch (e) {
            Object.assign(newUserData, {
              errorOnProfilePick: `${user.nombre_usuario.charAt(0)}${user.apellido.charAt(
                0
              )}`,
            });
          }

          this.leftContainer.cards.usersAvatars.push(newUserData);
        }
        _.each(this.leftContainer.cards.usersData, (user, i) => {
          const obj = _.find(this.leftContainer.cards.usersAvatars, {
            id_usuario: user.id_usuario,
          });
          if (obj && !user.profilePic) {
            Vue.set(this.leftContainer.cards.usersData, i, { ...user, ...obj });
          }
        });
      });
    },
    getListDocumentsWaiting(e, parameterLoad, firstLoaded) {
      const params = {};

      if (this.leftContainer.listOrder.orderType) {
        params.orderType = this.leftContainer.listOrder.orderType;
      }
      if (this.leftContainer.listOrder.orderBy) {
        params.orderBy = this.leftContainer.listOrder.orderBy;
      }

      const filters = this.mutations.formatParams();
      this.leftContainer.cards.searchingFromFilters = !_.isEmpty(filters);

      this.UserApi.getDocumentWaitingPerPage(this.documentPerPage, this.documentPage, {
        ...params,
        ...filters,
      })
        .then((response) => {
          const usersResponse = response.data.results.data;
          const pagination = response.data.pagination;
          this.leftContainer.totalDocuments = pagination.total;

          if (firstLoaded && usersResponse.length) {
            this.$refs.filters.generateRangeDateOptions();
            this.$refs.filters.getListDocumentsWaitingFilters();
          }

          if (!usersResponse.length && e) e.complete();
          if (usersResponse.length > 0) {
            this.noTasks = false;
            this.infiniteLoadingEnable = true;
            this.leftContainer.cards.usersData.push(...usersResponse);

            this.leftContainer.cards.usersData = _.uniqBy(
              this.leftContainer.cards.usersData,
              (t) => t.id_carga
            );

            this.leftContainer.cards.loadingCards = false;
            this.leftContainer.cards.searchingFromFilters === false;
            this.documentPage += 1;
            if (this.loadingView) this.loadingView = false;
            if (e) e.loaded();
            this.toggleDocumentState();
            this.getAvatarListByUser(usersResponse);
            if (parameterLoad === 'individual') {
              if (this.leftContainer.cards.usersData[this.taskApprovedIndex]) {
                this.selectCard(
                  this.leftContainer.cards.usersData[this.taskApprovedIndex]
                );
              } else if (this.leftContainer.cards.usersData[this.taskApprovedIndex - 1]) {
                this.selectCard(
                  this.leftContainer.cards.usersData[this.taskApprovedIndex - 1]
                );
              }
            } else {
              if (this.leftContainer.cards.usersData.length && !this.breakpointLG) {
                this.selectCard(this.leftContainer.cards.usersData[0]);
              }
            }
            if (this.rightContainer.rejectLoadData.rejectedSuccessful) {
              this.selectCard(this.leftContainer.cards.usersData[0]);
              this.rightContainer.rejectLoadData.rejectedSuccessful = false;
            }
          } else {
            this.leftContainer.cards.loadingCards = false;
            this.leftContainer.cards.searchingFromFilters === false;
            if (this.loadingView) this.loadingView = false;
          }
        })
        .catch((error) => {
          if (this.loadingView) this.loadingView = false;
          if (error.request.status === 404) {
            if (e) e.complete();
            this.leftContainer.cards.loadingCards = false;
            if (this.documentPage === 1 && !filters) this.noTasks = true;
            return;
          }
          if (error.response) {
            swal({
              type: 'warning',
              title: this.$t(
                'message.uploadImageComponent.errorLogs.' + error.response.data.code
              ),
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              reverseButtons: true,
              confirmButtonColor: '#54CAA6',
              confirmButtonText: this.$t(
                'message.uploadImageComponent.body.swalButtons.accept'
              ),
            }).then(() => {
              this.leftContainer.cards.loadingCards = false;
              this.leftContainer.cards.searchingFromFilters === false;
            });
          }
        });
    },
    async updateWaitingDocuments(parameterLoad, loadId) {
      if (parameterLoad === 'individual') {
        this.taskApprovedIndex = _.findIndex(
          this.leftContainer.cards.usersData,
          (task) => {
            return task.id_carga === loadId;
          }
        );

        this.documentPage = _.floor(this.taskApprovedIndex / this.documentPerPage) + 1;

        if (
          this.taskApprovedIndex === 0 &&
          this.leftContainer.cards.usersData.length > 1
        ) {
          this.leftContainer.cards.usersData = [this.leftContainer.cards.usersData[1]];
        } else if (
          this.taskApprovedIndex === 0 &&
          this.leftContainer.cards.usersData.length === 1
        ) {
          this.leftContainer.cards.usersData = [];
        } else {
          this.leftContainer.cards.usersData = _.slice(
            this.leftContainer.cards.usersData,
            0,
            this.taskApprovedIndex
          );
        }

        await this.getListDocumentsWaiting(null, parameterLoad);
      } else {
        this.documentPage = 1;
        this.leftContainer.cards.usersData = [];
        this.leftContainer.cards.loadingCards = true;
        this.$nextTick(() => {
          this.$refs.infiniteLoading.stateChanger.reset();
        });
      }
    },
    changeOrderRule(order) {
      this.leftContainer.listOrder.orderType = order.type;
      this.leftContainer.listOrder.orderBy = order.value;
      this.updateWaitingDocuments();
    },
    getOrderRule(value) {
      const obj = _.find(this.leftContainer.listOrder.orderRules, { value });
      if (obj) {
        return obj.label;
      }
    },
    getForMassiveUserArray() {
      if (this.leftContainer.isCheckAll) {
        const params = {};
        if (this.leftContainer.listOrder.orderType) {
          params.orderType = this.leftContainer.listOrder.orderType;
        }
        if (this.leftContainer.listOrder.orderBy) {
          params.orderBy = this.leftContainer.listOrder.orderBy;
        }
        const filters = this.mutations.formatParams();
        this.UserApi.getAllDocumentWaiting({ ...params, ...filters })
          .then((response) => {
            const pagination = response.data.pagination;
            const usersResponse = response.data.results.data;
            if (usersResponse.length > 0) {
              this.leftContainer.massiveArrayUsers.push(...usersResponse);
              this.leftContainer.totalDocuments = pagination.total;
              this.toggleDocumentState();
            }
          })
          .catch((err) => {
            this.leftContainer.massiveArrayUsers = [];
            this.leftContainer.totalDocuments = 0;
          });
      }
    },
    toggleDocumentState() {
      _.each(this.leftContainer.cards.usersData, (user, i) => {
        const obj = _.find(this.leftContainer.massiveArrayUsers, {
          id_carga: user.id_carga,
        });
        const properties = { hoverCard: false, selectedCard: _.isObject(obj) };
        Vue.set(this.leftContainer.cards.usersData, i, {
          ...user,
          ...properties,
        });
      });
    },
    scrollTopTaskSelected() {
      let selectedTasks = Array.from(
        document.getElementsByClassName('boxContainerSelected')
      );
      if (selectedTasks[0]) {
        selectedTasks[0].parentNode.scrollTop = selectedTasks[0].offsetTop - 286;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import './public/assets/scss/_config.scss';
@import 'bandejaMain.scss';
</style>
